import DseLabel from '@/components/DSE/DseLabel';
import { validatorRequire } from '@/utils/validators';
import Select from '@/components/DSE/Select';
import DateTimePicker from '@/components/DSE/DateTimePicker';
import CrudShipments from './CrudShipments';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'transportOrder.shipments'],
    groups: [
      {
        reference: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.reference'
          }
        },
        shipToCountryName: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.countryCode'
          }
        },
        shipmentAt: {
          type: DateTimePicker,
          props: {
            caption: 'transportOrder.shipmentAt',
            format: vue.$store.getters.dateTimeFormat
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        workshopNames: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.workshops'
          }
        },
        shipmentListTypeName: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.shipmentListTypeName'
          }
        },
        domainName: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.domainOrderNumberPrefix'
          }
        },
        deliveryType: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'orderLine.delivery'
          }
        },
        truckIdentifier: {
          type: Select,
          defaultValue: '',
          props: {
            caption: 'transportOrder.truckIdentifier',
            valueField: 'name',
            labelField: 'name',
            loading: vue.$store.getters['truck/isLoading'],
            options: vue.$store.getters['truck/loadedItems']
          }
        },
        storeAttributeName: {
          type: DseLabel,
          defaultValue: '',
          props: {
            caption: 'transportOrder.storeAttribute'
          }
        },
        exportedAt: {
          type: DateTimePicker,
          props: {
            caption: 'transportOrder.exportedAt',
            readonly: true,
            format: vue.$store.getters.dateTimeFormat
          }
        }
      },
      // Tab Shipments
      {
        stores: {
          type: CrudShipments,
          defaultValue: [],
          props: {
            tabbed: true,
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'transportOrderID',
            permissionCode: 'TransportOrder'
          }
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: ['truckIdentifier', 'shipmentAt']
    },
    {
      width: 50,
      fields: [
        'reference',
        'shipToCountryName',
        'deliveryType',
        'shipmentListTypeName',
        'domainName',
        'workshopNames',
        'storeAttributeName',
        'exportedAt'
      ]
    }
  ]
};
const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutFullWidth]
  };
}

export function createItemFromFormData(vue, form) {
  const item = {
    ...form
  };
  delete item.deliveryType;
  return item;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  form.deliveryType = item.deliverAtHomeYN ? this.$t('orderLine.deliver') : this.$t('orderLine.pickUp');
  return form;
}
